import { Grid, Typography, Paper, IconButton } from "@material-ui/core";
import { EditRounded } from "@material-ui/icons";
import React from "react";

const NewEmployeeShow = () => {
  return (
    <Paper style={{ width: "100%" }}>
      <Grid item container xs={12} spacing={2} style={{ margin: "auto" }}>
        {/* header section */}
        <Grid
          item
          xs={12}
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="button">کارمند جدید</Typography>
          <IconButton color="primary">
            <EditRounded />
          </IconButton>
        </Grid>
        {/* information section */}

        <Grid item container xs={12} justifyContent="space-between">
          <Grid item container xs={6}>
            {/* key info section */}
            <Grid
              item
              xs={3}
              container
              spacing={2}
              style={{ margin: "auto" }}
              direction="column"
            >
              {titles.map((item) => {
                return (
                  <Grid item key={item}>
                    <Typography variant="button">{item}</Typography>
                  </Grid>
                );
              })}
            </Grid>
            {/* value info section */}
            <Grid
              item
              xs={3}
              container
              spacing={2}
              style={{ margin: "auto" }}
              direction="column"
            >
              <Grid item>
                <Typography variant="button">امین حسینی</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">شسیشس@شسیشس.زخئ</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">********</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">09904505485</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">081245513341</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">کارمند</Typography>
              </Grid>
              <Grid item>
                <Typography variant="button">فعال</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            container
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={3}>
              <Typography variant="button">تاریخ عضویت :</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="button">1400/04/08</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default NewEmployeeShow;

const titles = [
  "نام و نام خوانوادگی :",
  "ایمیل :",
  "پسورد :",
  "شماره موبایل :",
  "شماره ثابت :",
  "گروع کاربری :",
  "وضعیت :",
];
